import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/round-rock")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Round Rock, TX | Texas Made Shade",
      description: "Custom welded awnings, sail shades, patio & pergola covers, marine canvas and aluminum fabrication for Round Rock & Williamson County.",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Round Rock, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Round Rock and Williamson County.",
      keywords: "awnings Round Rock, awning company Round Rock, custom awnings Round Rock, sail shades Round Rock, patio covers Round Rock, pergola covers Round Rock, metal awnings Round Rock, canvas awnings Round Rock, Texas Made Shade",
    }),
    scripts: cityHeadScripts("Round Rock", "Williamson County"),
  }),
  component: () => <CityHomePage city="Round Rock" region="Williamson County" />,
});
